<template>
  <main-page :user="user" hide-footer>
    <template v-slot:title>SECTIONS</template>

    <div
      class="container"
      v-if="showClasses"

    >
      <div class="d-flex flex-row align-items-center w-100 mt-5">
        <h1 class="flex-grow text-left si-font mb-0 pb-0">Your Classes:</h1>
        <template v-if="user.role == 'ADMIN' || user.role == 'TEACHER'">
          <button class="btn btn-round btn-warning mx-1" @click="openAddSectionModal">
            <i class="fas fa-fw mr-2 fa-plus"></i>Create Class
          </button>
          <button class="btn btn-round btn-warning mx-1" @click="openGClassesModal">
            <i class="fab fa-fw mr-2 fa-google"></i>Google Sync
          </button>
        </template>
      </div>
      <hr class="mb-0" />
      <div
        v-if="!loading"
        class="d-flex flex-row flex-wrap"
        style="margin-left: -20px; margin-right: -20px"
      >
        <template v-for="section in sections">
          <div
            v-if="!section.is_contest"
            :key="section.id"
            class="card mt-4 text-center clickable clickable-card"
            @click="goToPortfolio(section)"
          >
            <div class="card-header text-md warning _600">
              {{ section.name }}
              <i
                v-if="user.role == 'ADMIN' || user.role == 'TEACHER'"
                class="fas fa-edit float-right text-lg"
                @click="openEditSectionModal(section)"
              />
            </div>
            <div class="card-body d-flex flex-row text-md text-muted">
              <div class="flex-grow">
                <i class="fas fa-user-graduate mr-2" />{{ section.teacher_ids.length }}
                {{ section.teacher_ids.length > 1 ? "Teachers" : "Teacher" }}
              </div>
              <div class="flex-grow">
                <i class="fas fa-users mr-2" />{{ section.student_ids.length }}
                {{ section.student_ids.length > 1 ? "Students" : "Student" }}
              </div>
            </div>
          </div>
        </template>
        <template v-if="!(sections && sections.length > 0)">
          <div class="card box w-100 shadow-sm mt-4">
            <h1
              class="text-center my-5 text-very-muted w-100 _800 si-font"
              style="font-size: 64px"
            >
              No Classes
            </h1>
          </div>
        </template>
      </div>
    </div>
    <div
      class="container"
      v-if="showContests"
    >
      <div class="d-flex flex-row align-items-center w-100 mt-5">
        <h1 class="flex-grow text-left si-font mb-0 pb-0">Your Contests:</h1>
        <template v-if="user.role == 'ADMIN' || user.role == 'TEACHER'">
          <button class="btn btn-round btn-warning mx-1" @click="openAddContestModal">
            <i class="fas fa-fw mr-2 fa-plus"></i>Create Contest
          </button>
        </template>
      </div>
      <hr class="mb-0" />
      <div
        v-if="!loading"
        class="d-flex flex-row flex-wrap"
        style="margin-left: -20px; margin-right: -20px"
      >
        <template v-for="section in sections">
          <div
            v-if="section.is_contest"
            :key="section.id"
            class="card mt-4 text-center clickable clickable-card"
            @click="goToPortfolio(section)"
          >
            <div class="card-header text-md warning _600">
              {{ section.name }}
              <i
                v-if="user.role == 'ADMIN' || user.role == 'TEACHER'"
                class="fas fa-edit float-right text-lg"
                @click="openEditSectionModal(section)"
              />
            </div>
            <div class="card-body d-flex flex-row text-md text-muted">
              <div class="flex-grow">
                <i class="fas fa-user-graduate mr-2" />{{ section.teacher_ids.length }}
                {{ section.teacher_ids.length > 1 ? "Teachers" : "Teacher" }}
              </div>
              <div class="flex-grow">
                <i class="fas fa-users mr-2" />{{ section.student_ids.length }}
                {{ section.student_ids.length > 1 ? "Students" : "Student" }}
              </div>
            </div>
          </div>
        </template>
        <template v-if="!(sections && sections.length > 0)">
          <div class="card box w-100 shadow-sm mt-4">
            <h1
              class="text-center my-5 text-very-muted w-100 _800 si-font"
              style="font-size: 64px"
            >
              No Contests
            </h1>
          </div>
        </template>
      </div>
    </div>

    <!-- Add Section modal -->
    <b-modal id="addSectionModal" headerClass="warning">
      <template v-slot:modal-title>
        <h3 class="modal-title full-bar-title">
          Create {{ newSection.is_contest ? "Contest" : "Class" }}
        </h3>
      </template>
      <div class="p-2" v-if="newSection">
        <div class="form-group pl-2 pr-3">
          <label>Name:</label>
          <input type="text" v-model="newSection.name" class="form-control" />
        </div>
        <div class="form-group pl-2 pr-3">
          <label>Program:</label>
          <v-select
            label="name"
            :options="programs"
            v-model="newSection.program_id"
            :clearable="false"
            :reduce="(p) => p.id"
          ></v-select>
        </div>
        <div class="form-group pl-2 pr-3">
          <label>Description:</label>
          <textarea v-model="newSection.desc" class="form-control" />
        </div>
      </div>
      <template v-slot:modal-footer="{ ok, cancel }">
        <button type="button" class="btn btn-secondary" @click="cancel">Cancel</button>
        <button type="button" class="btn btn-success" @click="addSection(ok)">Add</button>
      </template>
    </b-modal>

    <b-modal id="editSectionModal" v-model="editModalOpen" eaderClass="warning">
      <template v-slot:modal-title>
        <h3 class="modal-title full-bar-title">
          Edit {{ newSection.is_contest ? "Contest" : "Class" }}
        </h3>
      </template>
      <div class="p-2" v-if="newSection">
        <div class="form-group pl-2 pr-3">
          <label>Name:</label>
          <input type="text" v-model="newSection.name" class="form-control" />
        </div>
        <div class="form-group pl-2 pr-3">
          <label>Description:</label>
          <textarea v-model="newSection.desc" class="form-control" />
        </div>
      </div>
      <template v-slot:modal-footer="{ ok, cancel }">
        <button type="button" class="btn btn-secondary" @click="cancel">Cancel</button>
        <button type="button" class="btn btn-success" @click="editSection(ok)">
          Save
        </button>
      </template>
    </b-modal>

    <b-modal id="gClassesModal" headerClass="indigo">
      <template v-slot:modal-title>
        <h3 class="modal-title full-bar-title">Google Classroom Classes</h3>
      </template>
      <div v-if="!gClasses" style="height: 400px">
        <loading type="page" />
      </div>
      <div v-if="gClasses" class="p-2">
        <template v-if="gClasses.length > 0">
          <template v-for="c in gClasses">
            <div
              :key="`class-${c.id}`"
              class="card clickable mt-2 mx-2 py-1 px-3 d-flex flex-row align-items-center"
              :class="{ 'gclass-selected': c.showDetails }"
              @click="toggleGClassDetails(c.id)"
            >
              <div class="truncate flex">
                <span
                  class="nowrap truncate text-md"
                  :class="{ 'text-muted': c.alreadyImported && !c.showDetails }"
                  >{{ c.name }}</span
                >
                <span v-if="c.alreadyImported" class="ml-1 text-muted text-xxs"
                  >(imported)</span
                >
              </div>
              <div class="text-center ml-3">
                <i
                  class="fas fa-caret-left fa-lg anim-rotate"
                  :class="{ 'rotate-90': c.showDetails }"
                ></i>
              </div>
            </div>
            <div
              :key="`details-${c.id}`"
              v-if="c.showDetails"
              class="card mx-2 py-2 px-3"
              style="min-height: 120px"
            >
              <div class="d-flex flex-column" v-if="!c.loading">
                <div class="d-flex flex-row align-items-center">
                  <div class="flex text-md">{{ c.descriptionHeading }}</div>
                  <i class="fab fa-lg fa-google" />
                </div>
                <div class="text-muted">{{ c.description }}</div>
                <hr class="border w-100 my-2" />
                <div class="mt-auto d-flex flex-row">
                  <div class="flex text-md">
                    <div v-if="c.teachers && c.teachers.length > 0">
                      <span v-tippy :title="teachersTooltip(c.teachers)">
                        <i class="fas fa-fw fa-users mr-1" />
                        {{ c.teachers.length }}
                        {{ c.teachers.length > 1 ? "teachers" : "teacher" }}
                      </span>
                    </div>
                    <div v-if="c.students && c.students.length > 0">
                      <span v-tippy :title="studentsTooltip(c.students)">
                        <i class="fas fa-fw fa-user mr-1" />
                        {{ c.students.length }}
                        {{ c.students.length > 1 ? "students" : "student" }}
                      </span>
                    </div>
                  </div>
                  <div class="d-flex flex-row justify-content-end align-items-end mb-1">
                    <button
                      v-if="!c.alreadyImported && !c.importing"
                      class="btn ml-2 btn-primary"
                      style="height: 35px"
                      @click="doClassImport(c)"
                    >
                      Import Class
                    </button>
                    <button
                      v-if="!c.alreadyImported && c.importing"
                      class="btn btn-primary ml-2"
                      disabled
                      style="height: 35px"
                    >
                      Importing...
                      <loading type="icon" />
                    </button>
                    <button
                      v-if="c.alreadyImported"
                      class="btn btn-secondary ml-2"
                      style="height: 35px"
                      disabled
                    >
                      Imported
                    </button>
                  </div>
                </div>
              </div>
              <div v-if="c.loading" class="text-muted text-center">
                <loading type="large" />
              </div>
            </div>
          </template>
        </template>

        <h3 v-if="gClasses.length == 0" class="text-extra-muted">
          You have no Google Classroom classes
        </h3>
      </div>
      <template v-slot:modal-footer="{ ok }">
        <button type="button" class="btn btn-primary" @click="ok">Done</button>
      </template>
    </b-modal>
  </main-page>
</template>

<script>
import MainPage from "@/components/MainPage";

import SectionService from "@/services/SectionService";
import ProgramService from "@/services/ProgramService";
import UserService from "@/services/UserService";
import AuthService from "@/services/AuthService";
import GClassService from "@/services/GClassService";
import Notie from "@/services/NotieService";
import _ from "lodash";

export default {
  name: "ClassList",

  props: ["user"],

  components: { MainPage },

  data() {
    return {
      loading: true,

      sections: null,
      classes: null,
      contests: null,

      gClasses: null,
      newSection: null,

      programs: [],
      editModalOpen: false,
    };
  },

  created() {
    this.loadClasses();
    this.loadPrograms();
  },

  computed: {
    showClasses() {
      if (!this.classes || !this.contests) {
        return true;
      }
      return this.classes.length > 0 || this.contests.length == 0;
    },
    showContests() {
      if (!this.classes || !this.contests) {
        return true;
      }
      return this.contests.length > 0 || this.classes.length == 0;
    }
  },

  methods: {
    loadClasses() {
      let call = SectionService.getMySectionsTeacher;
      if (
        this.user.role == "STUDENT" ||
        this.user.role == "PARTNER" ||
        this.user.role == "JUDGE"
      ) {
        call = SectionService.getMySectionsMember;
      }
      call()
        .then((r) => {
          this.sections = r.data;
          this.loading = false;

          this.classes = [];
          this.contests = [];
          for (var s of this.sections) {
            if (s.is_contest) {
              this.contests.push(s);
            } else {
              this.classes.push(s);
            }
          }
        })
        .catch((e) => {
          Notie.error("Failed to get classes", e);
        });
    },

    loadPrograms() {
      ProgramService.getDistrictPrograms(this.user.district_id)
        .then((r) => {
          this.programs = r.data;
        })
        .catch((e) => {
          console.error(e);
          Notie.error("Failed to load programs", e);
        });
    },

    openGClassesModal() {
      this.$bvModal.show("gClassesModal");

      GClassService.getGClasses()
        .then((r) => {
          this.gClasses = r.data;

          let importedClassesMap = {};
          _.each(this.sections, (s) => {
            if (s.external_id) {
              importedClassesMap[s.external_id] = true;
            }
          });
          _.each(this.gClasses, (gc) => {
            if (importedClassesMap[gc.id]) {
              gc.alreadyImported = true;
            }
          });
        })
        .catch((e) => {
          console.log(e);
          if (e.response.status == 403) {
            console.log("TOKEN EXPIRED");
            window.location.replace(`/v1/auth?provider=gplus`);
          } else {
            Notie.error("Failed to load Google classes", e);
            this.$bvModal.hide("gClassesModal");
          }
        });
    },

    toggleGClassDetails(gcID) {
      _.each(this.gClasses, (gc) => {
        if (gc.id == gcID) {
          if (gc.showDetails) {
            console.log("TURN OFF");
            gc.showDetails = false;
            this.$forceUpdate();
          } else {
            console.log("TURN ON");
            gc.showDetails = true;
            this.$forceUpdate();
            if (!gc.students) {
              this.$set(gc, "loading", true);
              GClassService.getGClassUsers(gc.id)
                .then((r) => {
                  gc.loading = false;
                  gc.teachers = r.data.teachers;
                  gc.students = r.data.students;
                })
                .catch((e) => {
                  console.log(e);
                  Notie.error("Failed to load Google Class details", e);
                });
            }
          }
        } else {
          gc.showDetails = false;
          this.$forceUpdate();
          delete gc.students;
        }
      });
    },

    teachersTooltip(teachers) {
      let tooltip = `<div class="text-left ml-4 mt-3">Teachers:</div>
			<ul class="text-left mt-3 mr-3">`;
      _.each(teachers, (teacher) => {
        tooltip += `<li>${teacher.profile.name.fullName} <span class="text-muted" style="font-size: 0.8rem;">(${teacher.profile.emailAddress})</span></li>`;
      });
      tooltip += "</ul>";
      return tooltip;
    },

    studentsTooltip(students) {
      let tooltip = `<div class="text-left ml-4 mt-3">Students:</div>
			<ul class="text-left mt-3 mr-3">`;
      _.each(students, (student) => {
        tooltip += `<li>${student.profile.name.fullName} <span class="text-muted" style="font-size: 0.8rem;">(${student.profile.emailAddress})</span></li>`;
      });
      tooltip += "</ul>";
      return tooltip;
    },

    doClassImport(gClass) {
      let sectionInfo = {
        curriculum_id: this.importingCurriculum,
        school_id: this.importingSchool,
        grade: this.importingGrade,
        period: this.importingPeriod,
      };
      this.$set(gClass, "importing", true);
      GClassService.importClass(gClass.id, sectionInfo)
        .then(() => {
          gClass.importing = false;
          gClass.alreadyImported = true;
          gClass.getInfo = false;
          Notie.success("Class imported from Google");
          this.loadClasses();
        })
        .catch((e) => {
          gClass.importing = false;
          console.log(e);
          if (e.response.status == 403) {
            console.log("TOKEN EXPIRED");
            window.location.replace(`/v1/auth?provider=gplus`);
          } else {
            Notie.error("Failed to import class", e);
          }
        });
    },

    openAddSectionModal() {
      this.newSection = {
        name: "New Class",
        desc: "",
      };
      this.$bvModal.show("addSectionModal");
    },

    openEditSectionModal(section) {
      this.newSection = JSON.parse(JSON.stringify(section));
      this.$bvModal.show("editSectionModal");
    },

    openAddContestModal() {
      this.newSection = {
        name: "New Contest",
        desc: "",
        is_contest: true,
      };
      this.$bvModal.show("addSectionModal");
    },

    addSection(callback) {
      SectionService.saveSection(this.newSection)
        .then(() => {
          Notie.success("Section created");
          callback();
          this.loadClasses();
        })
        .catch((e) => {
          console.log(e);
          Notie.error("Failed to create section", e);
        });
    },

    editSection(callback) {
      SectionService.saveSection(this.newSection)
        .then(() => {
          Notie.success("Section saved");
          callback();
          this.loadClasses();
        })
        .catch((e) => {
          console.log(e);
          Notie.error("Failed to save section", e);
        });
    },

    goToPortfolio(section) {
      if (this.editModalOpen) {
        return;
      }
      UserService.changeSection(section.id)
        .then(() => {
          AuthService.forceRefresh();
          if (this.user.role == "ADMIN" || this.user.role == "TEACHER") {
            this.$router.push("/class_details");
          } else if (this.user.role == "JUDGE") {
            this.$router.push("/pitch_entry");
          } else {
            this.$router.push("/portfolio");
          }
        })
        .catch((e) => {
          console.log(e);
          Notie.error("Failed to enter class", e);
        });
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.clickable-card {
  transition: transform 0.15s ease-in-out;
  background-color: #f7f7f7;
  width: calc(50% - 40px);
  margin-left: 20px;
  margin-right: 20px;
}
.clickable-card:hover {
  transform: scale(1.05);
}
</style>
